<template>
  <lu-vbox lu-flex style='padding: 10px;'>
    <lu-item style='margin-bottom: 0px !important;text-transform:uppercase;color:black;'>
      {{ $t('Contact us') }}
    </lu-item>

    <lu-vbox class='vpad-in-5 text-grey-6' lu-flex v-for='(data, idx) in contactList' :key='idx'>
      <lu-hbox class='entity'>
        <lu-item>{{ data.firstName}} {{ data.lastName }}</lu-item>
      </lu-hbox>
      <lu-hbox class='sub'>
        <lu-item class='titleVal'>{{ $t('Address') }}</lu-item>
        <lu-item lu-flex>{{ data.contractAddress }}</lu-item>
      </lu-hbox>
      <lu-hbox class='sub'>
        <lu-item class='titleVal'> {{ $t('Tel') }}</lu-item>
        <lu-item lu-flex>{{ data.phoneNumber }}</lu-item>
      </lu-hbox>
      <lu-hbox class='sub'>
        <lu-item class='titleVal'>{{ $t('Email') }}</lu-item>
        <lu-item lu-flex class='link-type'>
          <a target='_blank' @click="onMail(data.email)">{{data.email}}</a>
        </lu-item>
      </lu-hbox>
    </lu-vbox>


  </lu-vbox>
</template>

<script>
import { LuItem, LuVbox, LuHbox } from 'lusis-ui'
import { mapState } from 'vuex'

export default {
  name: 'Message',
  components: {
    LuItem,
    LuVbox,
    LuHbox
  },
  computed: {
    ...mapState({ contactList: state => state.user.contactList })
  },
  methods: {
    onMail (email) {
      window.open('mailto:' + email, 'mail')
      event.preventDefault()
    }
  }

  // asyncComputed: {
  //   contactList: {
  //     lazy: true,
  //     get: function () {
  //       this.$tango.getContactList().then(rep => {
  //         console.log(rep.contactList)
  //         return rep.contactList || []
  //         // let parsed = JSON.parse(rep.contactList.split('\\n').join('<br>'))
  //         // this.contactList = parsed ? (parsed.exchangeList || []) : []
  //       }).catch(err => {
  //         // eslint-disable-next-line no-console
  //         console.log(err)
  //       })
  //     },
  //     default: []
  //   }
  // }
}
</script>

<style scoped lang='scss'>
.entity {
  font-size: 1.3rem;
  background-color: #000000;
  margin-top: 10px;
  padding: 3px 20px;
}


.sub {
  padding: 2px 20px;
  color:black;

  .titleVal {
    width: 130px;
    font-size: 1.2rem;
  }
}
</style>